// @flow strict
import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'

import { getLocalisedFieldsFromNode } from '@mondough/contentful'
import MoreInformationSection from '../../components/bespoke/Business/MoreInformationSection/MoreInformationSection'
import CustomerProfileTriptych from '../../components/bespoke/Business/CustomerProfileTriptych/CustomerProfileTriptych'
import PricingTable from '../../components/bespoke/Business/PricingTable/PricingTable'
import CustomerQuoteDiptych from '../../components/bespoke/Business/CustomerQuoteDiptych/CustomerQuoteDiptych'
import ComparisonTable from '../../components/bespoke/Business/ComparisonTable/ComparisonTable'
import TrustMarkerStrip from '../../components/bespoke/TrustMarkerStrip/TrustMarkerStrip'
import { locale } from '../../Global'
import { subtitleNodeName } from '@mondough/contentful/src/richTextDecorators'
import { defaultSubtitleSection } from '../defaultThemeComponents'
import BusinessFeatureDiscoveryGrid from '../../components/bespoke/Business/BusinessFeatureDiscoveryGrid'

export const renderBusinessMoreInformationSection = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return (
    <MoreInformationSection
      title={bespokeContent && bespokeContent.title}
      description={bespokeContent && bespokeContent.description}
      businessIndustries={bespokeContent && bespokeContent.businessIndustries}
    />
  )
}

export const renderBusinessPricingTable = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return (
    <PricingTable
      featureGroups={bespokeContent && bespokeContent.feature_groups}
      plans={bespokeContent && bespokeContent.plans}
      title={bespokeContent && bespokeContent.title}
      footer={bespokeContent && bespokeContent.footer}
      signupLink={bespokeContent && bespokeContent.signupLink}
    />
  )
}

export const renderBusinessCustomerQuoteDiptych = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return (
    <CustomerQuoteDiptych
      sections={bespokeContent && bespokeContent.sections}
      readMoreLabel={bespokeContent && bespokeContent.readMoreLabel}
      readMoreURL={bespokeContent && bespokeContent.readMoreURL}
    />
  )
}

export const renderBusinessCustomerProfileTriptych = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return (
    <CustomerProfileTriptych items={bespokeContent && bespokeContent.items}>
      {node[subtitleNodeName] && defaultSubtitleSection(node[subtitleNodeName])}
    </CustomerProfileTriptych>
  )
}
export const renderBusinessComparisonTable = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return (
    <ComparisonTable
      subtitle={bespokeContent && bespokeContent.subtitle}
      blurb={bespokeContent && bespokeContent.blurb}
      features={bespokeContent && bespokeContent.features}
      banks={bespokeContent && bespokeContent.banks}
    />
  )
}

export const renderBusinessTrustMarkerStrip = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}

  return (
    <TrustMarkerStrip
      trustMarkers={bespokeContent && bespokeContent.trustMarkers}
    />
  )
}

export const renderBusinessFeatureDiscoveryGrid = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return (
    <BusinessFeatureDiscoveryGrid
      features={bespokeContent && bespokeContent.features}
    >
      {node[subtitleNodeName] && defaultSubtitleSection(node[subtitleNodeName])}
    </BusinessFeatureDiscoveryGrid>
  )
}
